<template>
  <div>
    <div class="row">
      <div class="flex xs12 lg12 text--center">
        <span style="font-size: 1.5rem"><span style="font-weight:bold">{{ this.itemType}}:</span> {{ this.itemName }}</span>
        <!-- <va-card
          title="Stuff"
          color="background2"
        >
        </va-card>-->
      </div>
    </div>
    <div v-if="!showingInv" class="row">
      <!-- row-equal makes all components in the row the ssame height -->
      <div class="flex xs12 sm4 md4">
        <loading-overlay :loading="loading">
          <va-card class="mb-1" :color="this.getIssuesColor()">
            <p class="display-2 mb-0" style="color: white">{{ errorCount }}</p>
            <!-- mb-0 means "margin bottom 0", display-2 is font size 2 -->
            <p>issues</p>
          </va-card>
        </loading-overlay>
      </div>
      <div class="flex xs12 md4">
        <loading-overlay :loading="loading">
          <va-card>
            <div class="row row-separated">
              <div class="flex xs6">
                <p class="display-2 mb-1 text--center" :style="{ color: 'green' }">{{ this.producingPercent }}</p>
                <p class="text--center mb-1">inverters producing</p>
                <!-- {{$t('dashboard.info.users')}}</p> -->
              </div>
              <div class="flex xs6">
                <p class="display-2 mb-1 text--center" :style="{ color: 'blue' }">{{ this.power }}</p>
                <p class="text--center no-wrap mb-1">total</p>
              </div>
            </div>
          </va-card>
        </loading-overlay>
      </div>
      <div v-if="showingGw" class="flex xs12 sm4 md4">
        <details-table :headings="['', '']" :rows="gwDatesData" :loading="loading" :striped="true"></details-table>
      </div>
    </div>

    <div v-if="showingInv" class="row">
      <div class="flex xs12 sm4 md4">
        <va-card :color="this.statusData.color" style="border-radius: 3em; text-align: center">
          <p class="display-2" style="color: white">{{ this.statusData.text }}</p>
        </va-card>
      </div>
      <div class="flex xs12 md4">
        <va-card style="border-radius: 3em; text-align: center">
          <p class="display-2">{{ this.statusData.power }}</p>
        </va-card>
      </div>
      <div class="flex xs12 sm4 md4">
        <details-table :headings="['', '']" :rows="invDatesData" :loading="loading" :striped="true"></details-table>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 lg12">
        <dashboard-charts :location="location" />
      </div>
    </div>

    <div v-if="showingInv" class="row">
      <div class="flex xs12 md4">
        <details-table
          title="Production"
          :subtitle="invProdSubtitle"
          :headings="['', '']"
          :rows="invProdData2"
          :headings2="['', 'Volts', 'Watts']"
          :rows2="invProdData"
          :loading="loading"
        ></details-table>
      </div>
      <div class="flex xs12 md4">
        <details-table title="Health" :subtitle="invHealthSubtitle" :headings="['', '']" :rows="invHealthData" :loading="loading"></details-table>
      </div>
      <div class="flex xs12 md4">
        <details-table title="Grid RMS" :subtitle="invGridSubtitle" :headings="['', 'Vmax', 'Vmin', 'Imax', 'Imin']" :rows="invGridData" :loading="loading"></details-table>
      </div>
    </div>
    <div v-if="showingInv && invHasFaults" class="row">
      <div class="flex xs12 md4">
        <details-table title="Faults" :subtitle="invProdSubtitle" :headings="['', '']" :rows="invFaultCodes" :loading="loading"></details-table>
      </div>
    </div>
    <div v-if="showingInv && false" class="row" style="background-color: #ff1d5e2b">
      <!-- <va-collapse :withBackground="true" :isOpenDefault="false" class="flex md12">
        <span slot="header">Advanced</span>
        <div slot="body" class="row"> -->
      <div class="flex xs12 md4">
        <details-table title="Details" subtitle :headings="['', '']" :rows="invDetailsData" :loading="loading"></details-table>
      </div>
      <!-- <div class="flex xs12 md4">
            <details-table
              title="Faults"
              subtitle
              :headings="['', '']"
              :rows="invFaultData"
              :loading="loading"
            ></details-table>
          </div> -->
      <div class="flex xs12 md4">
        <details-table
          title="Grid (Peaks)"
          subtitle
          :headings="['', 'Vmax', 'Vmin', 'Imax', 'Imin']"
          :rows="invGridPeaksData"
          :headings2="['', '']"
          :rows2="invGridPeaksData2"
          :loading="loading"
        ></details-table>
      </div>
      <!-- </div>
      </va-collapse> -->
    </div>

    <div v-if="showingGw" class="row">
      <div class="flex xs12 md4">
        <details-table title="Details" :subtitle="gwDetailSubtitle" :headings="['', '']" :rows="gwDetailData" :loading="loading"></details-table>
      </div>
      <div class="flex xs12 md4">
        <details-table title="Environment" :subtitle="gwDetailSubtitle" :headings="['', '']" :rows="gwEnvData" :loading="loading"></details-table>
      </div>
    </div>

    <div v-if="showingSite" class="row">
      <div class="flex xs12 md4">
        <details-table title="Address" :subtitle="siteDetailSubtitle" :headings="['', '']" :rows="siteAddressData" :loading="loading" :striped="false"></details-table>
      </div>
      <div class="flex xs12 md4">
        <details-table title="Details" :subtitle="siteDetailSubtitle" :headings="['', '']" :rows="siteDetailData" :loading="loading"></details-table>
      </div>
    </div>

    <div v-if="showingInv && false" class="row">
      <div class="flex xs12 lg12" style="background-color: #ff1d5e2b">
        <dashboard-events-table :location="location" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCharts from './DashboardCharts'
import DashboardEventsTable from './DashboardEventsTable'
import DetailsTable from './DetailsTable'
import LoadingOverlay from './LoadingOverlay'

import hiqapi from '@/hiqapi/hiqapi'

import { getInvStateColor, formatPower, formatVolts, formatWatts, formatAmps, formatTemp, formatPct, formatGwTime, formatInt, formatDate, formatNum, hoursAgo } from '@/common'

export default {
  name: 'DashboardInfoBlock',
  components: {
    DashboardCharts,
    DashboardEventsTable,
    DetailsTable,
    LoadingOverlay,
  },
  props: ['location', 'summaryData'],
  data() {
    return {
      invData: [],
      gwData: [],
      siteData: [],
      loading: false,
      infoTiles: [
        {
          color: 'success',
          value: '83',
          text: 'invertersProducing',
          icon: '',
        },
        {
          color: 'info',
          value: '124',
          text: 'totalkw',
          icon: '',
        },
        {
          color: 'danger',
          value: '5',
          text: 'issues',
          icon: '',
        },
      ],
    }
  },
  watch: {
    location: {
      immediate: true, // so this is called at startup (in addition to subsequent changes),
      deep: true,
      handler(val, oldVal) {
        if (!val.selectedId) {
          console.log('DIB-LOCATION ignoring location change because selectedId not set')
          return
        }

        console.log(`DIB-LOCATION will get chart for site=${val.siteId} gw=${val.gwSerial} type=${val.listType} sel=${val.selectedId}`)

        this.loading = true

        switch (val.listType) {
          case val.TYPE_INVS:
            this.invData.last_state = 'none'
            this.invData.last_output_watts = null
            hiqapi.getcb(`/inverters/${val.selectedId}?include_acdata=true&include_healthdata=true`, this.setInvData)
            break

          case val.TYPE_GWS:
            hiqapi.getcb(`/gateways/${val.selectedId}`, this.setGwData)
            break

          case val.TYPE_SITES:
            hiqapi.getcb(`/sites/${val.selectedId}`, this.setSiteData)
            break
        }
      },
    },
  },
  computed: {
    showingSite() {
      return this.location.listType === this.location.TYPE_SITES
    },
    showingGw() {
      return this.location.listType === this.location.TYPE_GWS
    },
    showingInv() {
      return this.location.listType === this.location.TYPE_INVS
    },
    invHasFaults() {
      return this.invData.last_hv_faults > 0 || this.invData.last_lv_faults > 0
    },
    invFaultCodes() {
      let res = []
      if (this.invData.last_hv_faults > 0) {
        res.push(['AC', this.invData.last_hv_faults_codes.join(' ')])
      }
      if (this.invData.last_lv_faults > 0) {
        res.push(['DC', this.invData.last_lv_faults_codes.join(' ')])
      }
      return res
    },

    gwDatesData: function() {
      let ltColor = ''
      if (hoursAgo(this.gwData.last_date_updated) > 24) {
        ltColor = 'red'
      }
      let resp = [['Last Contact', { value: formatGwTime(this.gwData.last_date_updated), color: ltColor }]]

      if (this.gwData.last_sent_gw_time === this.gwData.last_gw_time) {
        resp.push(['Last Timestamp', formatGwTime(this.gwData.last_sent_gw_time)])
      } else {
        resp.push(['Last Timestamp', { value: formatGwTime(this.gwData.last_sent_gw_time), color: 'red' }])
        resp.push(['Latest Timestamp', { value: formatGwTime(this.gwData.last_gw_time), color: 'red' }])
      }
      return resp
    },

    invDatesData: function() {
      let lcColor = ''
      let ltColor = ''
      let lpColor = ''
      if (hoursAgo(this.invData.last_contact_date) > 6) {
        lcColor = 'red'
      }
      if (hoursAgo(this.invData.last_production_date) > 24) {
        lpColor = 'red'
      }
      let resp = [
        ['Last Contact', { value: formatGwTime(this.invData.last_contact_date), color: lcColor }],
        ['Last Timestamp', { value: formatGwTime(this.invData.last_gw_time), color: ltColor }],
        ['Last Production', { value: formatGwTime(this.invData.last_production_date), color: lpColor }],
      ]
      return resp
    },

    statusData() {
      return { text: this.$t('dashboard.invStates.' + this.invData.last_state), color: getInvStateColor(this.invData.last_state), power: formatPower(this.invData.last_output_watts) } // "info", text: "Generating", power: "123kW"} //$5("dashboard.invStates.")
    },
    invProdSubtitle() {
      return formatGwTime(this.invData.last_gw_time)
    },
    invProdData: function() {
      return [
        ['String 1', formatVolts(this.invData.last_string1_v), formatWatts(this.invData.last_string1_w)],
        ['String 2', formatVolts(this.invData.last_string2_v), formatWatts(this.invData.last_string2_w)],
      ]
    },
    invProdData2: function() {
      return [['Power', formatPower(this.invData.last_output_watts)]]
    },

    invHealthSubtitle() {
      return formatGwTime(this.invData.last_healthdata_gw_time)
    },
    invHealthData: function() {
      return [
        ['AC Temp', formatTemp(this.invData.last_temp1)],
        ['DC Temp', formatTemp(this.invData.last_temp3)],
        ['Case Temp', formatTemp(this.invData.last_temp2)],
      ]
    },
    invGridSubtitle() {
      return formatGwTime(this.invData.last_acdata_gw_time)
    },
    invGridData: function() {
      return [
        [
          'Ph 1',
          formatVolts(this.invData.last_phase1_vrms_max),
          formatVolts(this.invData.last_phase1_vrms_min),
          formatAmps(this.invData.last_phase1_irms_max),
          formatAmps(this.invData.last_phase1_irms_min),
        ],
        [
          'Ph 2',
          formatVolts(this.invData.last_phase2_vrms_max),
          formatVolts(this.invData.last_phase2_vrms_min),
          formatAmps(this.invData.last_phase2_irms_max),
          formatAmps(this.invData.last_phase2_irms_min),
        ],
        [
          'Ph 3',
          formatVolts(this.invData.last_phase3_vrms_max),
          formatVolts(this.invData.last_phase3_vrms_min),
          formatAmps(this.invData.last_phase3_irms_max),
          formatAmps(this.invData.last_phase3_irms_min),
        ],
      ]
    },

    invDetailsData() {
      return [
        ['Mode', this.invData.last_mode],
        ['Status', this.invData.last_status],
        ['kWh', formatNum(this.invData.last_kwh, 1)],
        ['Str1 Status', this.invData.last_string1_status],
        ['Str2 Status', this.invData.last_string2_status],
        ['Anti-is. Min', formatInt(this.invData.last_anti_island_min)],
        ['Anti-is. Max', formatInt(this.invData.last_anti_island_max)],
        ['PLC Signal', formatInt(this.invData.last_plc_signal)],
        ['PLC Noise', formatInt(this.invData.last_plc_noise)],
        ['Moisture', formatPct(this.invData.last_condensation)],
      ]
    },
    // invFaultData () {
    //   return [ ['HV Faults', formatFlags(this.invData.last_hv_faults)],
    //     ['HV L Faults', formatFlags(this.invData.last_hv_latched_faults)],
    //     ['LV Faults', formatFlags(this.invData.last_lv_faults)],
    //     ['LV L Faults', formatFlags(this.invData.last_lv_latched_faults)],
    //     ['&nbsp;', ''],
    //     ['Event Flags', formatFlags(this.invData.last_event_flags)],
    //   ]
    // },
    invGridPeaksData: function() {
      return [
        [
          'Ph 1',
          formatVolts(this.invData.last_phase1_vpeak_max),
          formatVolts(this.invData.last_phase1_vpeak_min),
          formatAmps(this.invData.last_phase1_ipeak_max),
          formatAmps(this.invData.last_phase1_ipeak_min),
        ],
        [
          'Ph 2',
          formatVolts(this.invData.last_phase2_vpeak_max),
          formatVolts(this.invData.last_phase2_vpeak_min),
          formatAmps(this.invData.last_phase2_ipeak_max),
          formatAmps(this.invData.last_phase2_ipeak_min),
        ],
        [
          'Ph 3',
          formatVolts(this.invData.last_phase3_vpeak_max),
          formatVolts(this.invData.last_phase3_vpeak_min),
          formatAmps(this.invData.last_phase3_ipeak_max),
          formatAmps(this.invData.last_phase3_ipeak_min),
        ],
      ]
    },
    invGridPeaksData2: function() {
      return [
        ['Freq. Min', formatNum(this.invData.last_freq_min, 2)],
        ['Freq. Max', formatNum(this.invData.last_freq_max, 2)],
      ]
    },

    gwDetailSubtitle() {
      return formatGwTime(this.gwData.last_gw_time)
    },
    gwDetailData() {
      return [
        ['IP Address', this.gwData.last_ip_address],
        ['Inv Config.', formatInt(this.gwData.last_inverters_configured)],
        ['Inv Seen', formatInt(this.gwData.last_inverters_seen)],
      ]
    },
    gwEnvData() {
      return [
        ['Case Temp', formatTemp(this.gwData.last_temp_case)],
        ['Moisture', formatPct(this.gwData.last_condensation)],
        ['PLC Signal', formatInt(this.gwData.last_plc_signal)],
        ['PLC Noise', formatInt(this.gwData.last_plc_noise)],
      ]
    },

    siteDetailSubtitle() {
      return ''
    },
    siteAddressData() {
      let res = []
      res.push(['', this.siteData.address])
      if (this.siteData.address2) {
        res.push(['', this.siteData.address2])
      }
      res.push(['', `${this.siteData.city}, ${this.siteData.state} ${this.siteData.postalcode}`])
      res.push(['', `${this.siteData.country}`])
      return res
    },
    siteDetailData() {
      // Break tz across two lines
      let tz = this.siteData.timezone
      if (tz) {
        let tzp = tz.split('/')
        if (tzp.length === 2) {
          tz = tzp[0] + '/<br>' + tzp[1]
        }
      }
      return [
        ['Longitude', this.siteData.longitude],
        ['Latitude', this.siteData.latitude],
        ['Timezone', tz],
        ['Commissioned', formatDate(this.siteData.date_commissioned)],
      ]
    },
    itemType() {
      if (this.showingSite) {
        return 'Site'
      }
      if (this.showingGw) {
        return 'Gateway'
      }
      if (this.showingInv) {
        return 'Inverter'
      }
      return '??'
    },
    itemName: function() {
      // THIS IS NOT CORRECT LOGIC?
      if (!this.summaryData) {
        return ''
      }
      if (this.summaryData.name.endsWith(`#${this.summaryData.item_id}`)) {
        return this.summaryData.name
      } else {
        return `${this.summaryData.name} (#${this.summaryData.item_id})`
      }
    },
    power: function() {
      if (!this.summaryData || (this.summaryData.paid_thru_expired === 1 && this.$cookie.get('qea') !== 'true')) {
        return '-'
      }
      return formatPower(this.summaryData.power)
    },
    producingPercent: function() {
      if (!this.summaryData) {
        return ''
      }
      if (this.summaryData.invs_total === 0) {
        return '-'
      }
      return Math.ceil((100.0 * this.summaryData.invs_gen) / this.summaryData.invs_total) + '%'
    },
    errorCount: function() {
      if (this.summaryData) {
        if (this.summaryData.invs_total === 0) {
          if (this.summaryData.paid_thru_expired && this.$cookie.get('qea') !== 'true') {
            return ''
          } else {
            return '(No inverters)'
          }
        }
        return this.summaryData.error_count
      }
      return ''
    },
  },
  methods: {
    getIssuesColor() {
      if (!this.summaryData) {
        return 'gray'
      }
      if (this.summaryData.invs_total === 0) {
        return 'warning'
      }
      if (this.summaryData.error_count === 0) {
        return 'success'
      }
      return 'danger'
    },
    setInvData(newval) {
      console.log('SET INV DATA', newval.last_status, newval.last_output_watts)
      this.loading = false
      this.invData = newval
    },
    setGwData(newval) {
      this.loading = false
      this.gwData = newval
    },
    setSiteData(newval) {
      this.loading = false
      this.siteData = newval
    },
  },
}
</script>

<style lang="scss">
.row-separated {
  .flex + .flex {
    border-left: 1px solid #e3eaeb;
  }

  @include media-breakpoint-down(xs) {
    p:not(.display-2) {
      font-size: 0.875rem;
    }
  }
}

.dashboard {
  .va-card__header--over {
    @include media-breakpoint-up(md) {
      padding-top: 0 !important;
    }
  }

  .va-card__image {
    @include media-breakpoint-up(md) {
      padding-bottom: 0 !important;
    }
  }
}
</style>
